export default __webpack_public_path__ + "static/media/appointment.cac94ae3.png";